export default "__VITE_ASSET__17677943__"